import React from 'react'

const MobileStepIndicator = ({
  currentStep = 0,
  totalSteps = 0,
}) => {

  if (!totalSteps) {
    return null
  }

  return (
    <div className="mobile-steps-indicator-wrapper">
      {[...Array(totalSteps).keys()].map((index) => (
        <div
          key={index}
          className={`mobile-step-indicator ${ index === currentStep ? 'current' : index < currentStep ? 'previous' : 'next' }`}
        />
      ))}
    </div>
  )
}

export default MobileStepIndicator
